<template>
  <div class="card-filter">
    <el-row
      type="flex"
      align="start"
      justify="space-between"
      class="flex-wrap mb-l gap-12"
    >
      <el-row
type="flex"
align="middle">
        <el-select
          v-model="type"
          size="medium"
          class="w-100 mr-m"
          placeholder="Loại"
          filterable
          @change="searchNormal"
        >
          <el-option
            v-for="item in fileTypes"
            :key="item.key"
            :label="item.label"
            :value="item.key"
          />
        </el-select>
        <el-input
          v-model="text"
          class="text-search mr-m"
          size="medium"
          placeholder="Nhập thông tin để tìm kiếm"
          clearable
        />
        <el-button
          size="medium"
          type="primary"
          plain
          icon="el-icon-search"
          @click="searchNormal"
        >
          Tìm kiếm
        </el-button>
      </el-row>
    </el-row>
  </div>
</template>

<script>
export default {
  name: "CardFilter",
  props: {
    textSearch: String,
    fileType: String,
    fileTypes: Array,
  },
  data() {
    return {
      text: this.textSearch || "",
      type: this.fileType,
    };
  },
  methods: {
    searchNormal() {
      this.$emit("search", {
        fileType: this.type,
        textSearch: this.text,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.card-filter {
  .text-search {
    min-width: 200px;
  }
}
</style>
